import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_INSTANCE_ACTIONS from '../Actions/ActionTypes';
import { lecturerAccessForModulesInitState } from './CourseInstanceInitState';

export const lecturerAccessForModulesReducer = (
  state: IApiJsonResponse<Array<number>> = lecturerAccessForModulesInitState,
  action: IAction<IApiJsonResponse<Array<number>>>
): IApiJsonResponse<Array<number>> => {
  switch (action.type) {
    case COURSE_INSTANCE_ACTIONS.FETCH_LECTURER_ACCESS_FOR_MODULE:
      return { ...action.payload };

    default:
      return state;
  }
};
